module.exports = __webpack_public_path__ + "static/media/loading-spinner.a228edac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading-spinner.gif
// module id = 10
// module chunks = 1